<div class="empty-block">
  <div class="empty-block-icon">
    <svg viewBox="0 0 50 42">
      <use href="#empty-posts" />
    </svg>
  </div>
  <div class="empty-block-title"> There are currently no updates. </div>
</div>
